import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
// import Restaurants from "./Restaurants";
import Dashboard from "./Dashboard";
import CustomerGroups from "./CustomerGroups";
import RulesPurchase from "./RulesPurchase";
import Reports from "./Reports";
import LicensePlans from "./LicensePlans";
import SMSPlans from "./SMSPlans";
import PaymentResult from "./PaymentResult";
import SuspectsOrBlocks from "./SuspectsOrBlocks";
import Polls from "./Polls";
import Loading from "../../components/Loading";
import Events from "./Events";
import MessagePatterns from "./MessagePatterns";
// import 'ag-grid-community/dist/styles/ag-grid.css';
// import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

export default class RestaurantsListt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      serverResponse: false,
      userName: "",
    };
  }

  componentDidMount() {
    // if (localStorage.getItem("token")) {
    //   fetch("https://94.101.187.196/api/User/GetUserInfo", {
    //     method: "GET",
    //     headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    //   })
    //     .then((res) => {
    //       // console.log(res);
    //       if (res.status === 401) {
    //         localStorage.clear();
    //       } else {
    //         return res.json();
    //       }
    //     })
    //     .then((result) => {
    //       this.setState({
    //         serverResponse: true,
    //         userName: result.results[0].name,
    //       });
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // } else {
    //   localStorage.clear();
    // }

    this.setState({
      serverResponse: true,
      // userName: result.results[0].name,
    });
  }

  onBuySmsClick(id) {
    this.props.history.push(this.props.match.url + `/SMSPlans`);
  }

  onBuyLicenseClick(id) {
    this.props.history.push(this.props.match.url + `/LicensePlans`);
  }

  onClickRestaurant(id) {
    // this.props.history.push(this.props.match.url + `/${id}`);
  }

  onRulesPurchaseClick(id) {
    this.props.history.push(this.props.match.url + `/RulesPurchase`);
  }

  onCustomerGroupsClick(id) {
    this.props.history.push(this.props.match.url + `/CustomerGroups`);
  }

  onPollsClick(id) {
    this.props.history.push(this.props.match.url + `/Polls`);
  }

  onReportsClick(id) {
    this.props.history.push(this.props.match.url + `/Reports`);
  }

  onMessagePatterns(id) {
    this.props.history.push(this.props.match.url + `/MessagePatterns`);
  }

  onEvents(id) {
    this.props.history.push(this.props.match.url + `/Events`);
  }

  goToBusinessList() {
    this.props.history.push("/Restaurants");
  }

  onGoToSuspectsOrBlocks(id) {
    this.props.history.push(this.props.match.url + `/SuspectsOrBlocks`);
  }

  render() {
    if (this.state.serverResponse) {
      return (
        <div>
          <Switch>
            {/* <Route
            exact
            path={this.props.match.path}
            render={(props) => (
              <Restaurants
                {...props}
                showLogo={true}
                userName={this.state.userName}
                onBuySmsClick={this.onBuySmsClick.bind(this)}
                onBuyLicenseClick={this.onBuyLicenseClick.bind(this)}
                onClickRestaurant={this.onClickRestaurant.bind(this)}
              />
            )}
          /> */}
            {/* <Route exact path={`${this.props.match.path}/CreateNew`} render={(props) => (<CreateNewRestaurant {...props} onCreateNewRestaurantNext={this.onCreateNewRestaurantNext.bind(this)} />)}/> */}
            {/* <Route path={`${this.props.match.path}/:id/Edit`} render={(props) => (<CreateNewRestaurant {...props} isEdit={true} onCreateNewRestaurantNext={this.onCreateNewRestaurantNext.bind(this)}/>)}/> */}
            <Route
              exact
              path={this.props.match.path}
              render={(props) => (
                <Dashboard
                  {...props}
                  goToBusinessList={this.goToBusinessList.bind(this)}
                  onRulesPurchaseClick={this.onRulesPurchaseClick.bind(this)}
                  onCustomerGroupsClick={this.onCustomerGroupsClick.bind(this)}
                  onPollsClick={this.onPollsClick.bind(this)}
                  onReportsClick={this.onReportsClick.bind(this)}
                  onMessagePatterns={this.onMessagePatterns.bind(this)}
                  onEvents={this.onEvents.bind(this)}
                />
              )}
            />
            <Route
              path={`${this.props.match.path}/CustomerGroups`}
              render={(props) => <CustomerGroups {...props} />}
            />
            <Route
              path={`${this.props.match.path}/RulesPurchase`}
              render={(props) => <RulesPurchase {...props} />}
            />
            <Route
              path={`${this.props.match.path}/Reports`}
              render={(props) => (
                <Reports
                  {...props}
                  onGoToSuspectsOrBlocks={this.onGoToSuspectsOrBlocks.bind(
                    this
                  )}
                />
              )}
            />
            <Route
              path={`${this.props.match.path}/LicensePlans`}
              render={(props) => <LicensePlans {...props} />}
            />
            <Route
              path={`${this.props.match.path}/SMSPlans`}
              render={(props) => <SMSPlans {...props} />}
            />
            <Route
              path={`${this.props.match.path}/PaymentResult`}
              render={(props) => <PaymentResult {...props} />}
            />
            <Route
              path={`${this.props.match.path}/Polls`}
              render={(props) => <Polls {...props} />}
            />
            <Route
              path={`${this.props.match.path}/SuspectsOrBlocks`}
              render={(props) => <SuspectsOrBlocks {...props} />}
            />
            <Route
              path={`${this.props.match.path}/MessagePatterns`}
              render={(props) => <MessagePatterns {...props} />}
            />
            <Route
              path={`${this.props.match.path}/Events`}
              render={(props) => <Events {...props} />}
            />
          </Switch>
        </div>
      );
    } else {
      return <Loading />;
    }
  }
}
